import { render, staticRenderFns } from "./worksOfExcellence.vue?vue&type=template&id=f2b7b84c&scoped=true"
import script from "./worksOfExcellence.vue?vue&type=script&lang=js"
export * from "./worksOfExcellence.vue?vue&type=script&lang=js"
import style0 from "./worksOfExcellence.vue?vue&type=style&index=0&id=f2b7b84c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b7b84c",
  null
  
)

export default component.exports